(() => {
  const selector = '[data-apex-trustpilot] .trustpilot-widget';
  const source = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

  function mount(root = document) {
    if (!window.Trustpilot || !window.Trustpilot.loadFromElement) return;
    root.querySelectorAll(selector).forEach((element) => {
      if (!element.querySelector('iframe')) window.Trustpilot.loadFromElement(element, true);
    });
  }

  if (window.apexTrustpilotInitialized) {
    mount();
    return;
  }
  window.apexTrustpilotInitialized = true;
  document.addEventListener('shopify:section:load', (event) => mount(event.target));

  if (window.Trustpilot) {
    mount();
    return;
  }
  const existing = Array.from(document.scripts).find((script) => script.src === source);
  if (existing) {
    existing.addEventListener('load', () => mount(), { once: true });
    return;
  }
  const script = document.createElement('script');
  script.src = source;
  script.async = true;
  script.addEventListener('load', () => mount(), { once: true });
  document.head.appendChild(script);
})();
